import React from "react";

export default function NotFound() {
  return <div>not found</div>;
}
